import { Box, Stack } from "@mui/material"
import { Tabs } from "lib/@components/tabs"
import { HelpTag } from "routes/help/helpTag"
import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import { GetStartedCard } from "./get-started-card"

export function OptimiserPage() {
    return (
        <PageBreadcrumbContainer title="Optimiser" hideCrumbs sx={{ height: 1 }}>
            <HelpTag tags={[]} />
            <Stack
                data-cy="optimiser-page"
                spacing={1.5}
                sx={{
                    flex: 1,
                    mt: 3,
                    "& .MuiTypography-body2, & .MuiTypography-subtitle2": { fontSize: 16 },
                }}
            >
                <GetStartedCard />
                <Box flex={1}>
                    <Tabs
                        id="optimiser"
                        searchParam
                        tabHolder={<Box />}
                        panelHolder={<Box sx={{ marginTop: "3px" }} />}
                    />
                </Box>
            </Stack>
        </PageBreadcrumbContainer>
    )
}
